import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function JoinLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"join_left"}/>
}
